import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'boma-interactive-card',
  templateUrl: './interactive-card.component.html',
  styleUrls: ['./interactive-card.component.scss'],
})
export class InteractiveCardComponent implements OnInit {
  @Input() lockPosition = true;
  @Input() images = null;
  @Input() background = '';
  @Input() axis = { x: true, y: true };
  @Input() id = 'card';
  @Input() width = 'auto';
  @Input() height = 'auto';
  @Input() faceRight = true;
  @Input() startingRotation = { x: '0', y: '0' };
  el: any;

  constructor() {}

  setProp = (el, prop, value) => el.style.setProperty(prop, value);

  ngOnInit(): void {
    this.el = document.getElementById(this.id);
    this.resetProps();
    this.setProp(this.el, '--background', `url(${this.background})`);
    this.setProp(this.el, 'width', `${this.width}`);
    this.setProp(this.el, 'height', `${this.height}`);

    const onMouseUpdate = (e) => {
      const width = this.el.offsetWidth;
      const XRel = e.pageX - this.el.offsetLeft;
      const YRel = e.pageY - this.el.offsetTop;

      let YAngle = this.axis.y ? -(0.5 - XRel / width) * 10 : 0;
      const XAngle = this.axis.x ? (0.5 - YRel / width) * 10 : 0;

      if (!this.faceRight) YAngle = YAngle * -1; // graphic faces left

      this.setProp(this.el, '--dy', `${YAngle}deg`);
      this.setProp(this.el, '--dx', `${XAngle}deg`);
    };

    this.el.addEventListener('mousemove', onMouseUpdate, false);
    this.el.addEventListener('mouseenter', onMouseUpdate, false);
    if (!this.lockPosition)
      this.el.addEventListener('mouseleave', this.resetProps, false);
  }

  resetProps = () => {
    this.el.style.setProperty('--dy', `${this.startingRotation.y}deg`);
    this.el.style.setProperty('--dx', `${this.startingRotation.x}deg`);
  };
}
